import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";
import { mapSource, mapStatus } from "./mappers/screening.mapper";
import { ScreeningFilters } from "./types";

export function useFetchScreenings(filters: ScreeningFilters, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      tenantDocumentNumber: filters.tenantDocumentNumber?.trim() || undefined,
      status: filters.status
        ? mapStatus[filters.status as keyof typeof mapStatus]
        : undefined,
      source: filters.source
        ? mapSource[filters.source as keyof typeof mapSource]
        : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending } = useQuery({
    ...trpc.screenings.list.queryOptions(queryInput),
    enabled: !!merchant?.id,
  });

  return {
    screenings: data?.screenings ?? [],
    nextCursor: data?.cursor || undefined,
    isLoading: isPending,
  };
}
